<p-card class="col-12">
    <!-- Título de la cartera con skeleton -->
    <h1 class="main-title" style="margin-top: 0px;">
        <ng-container *ngIf="!loading; else skeletonTitle">
            {{ wallet.wallet.name }}
        </ng-container>
    </h1>

    <!-- Skeletons de Cards -->
    <div class="flex col-12" *ngIf="loading; else content">
        <div class="col-4">
            <div class="skeletons-container">
                <p-card class="col-4 card-wallet skeleton-card">
                    <div class="flex flex-column gap-3">
                        <div class="p-card-container wallet-section">
                            <p class="p-card-text">Creado por: <p-skeleton width="8rem" /></p>
                        </div>
                        <div class="p-card-container wallet-section">
                            <p class="p-card-text">Arrendamientos activos: <p-skeleton width="4rem" /></p>
                        </div>
                    </div>
                </p-card>
                <p-card class="col-4 card-wallet skeleton-card">
                    <div class="flex flex-column gap-3">
                        <div class="p-card-container wallet-section">
                            <p class="p-card-text">Valor cartera: <p-skeleton width="6rem" /></p>
                        </div>
                        <div class="p-card-container wallet-section">
                            <p class="p-card-text">Cartera sin accesorios: <p-skeleton width="6rem" /></p>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </div>

    <!-- Contenido real cuando loading es false -->
    <ng-template #content>
        <div class="flex gap-3">
            <!-- Tarjeta de información principal -->
            <p-card class="col-4 card-wallet">
                <div class="flex flex-column gap-3">
                    <div class="p-card-container wallet-section">
                        <p class="p-card-text">Creado por: <strong>{{ wallet.wallet.createdBy.names + ' ' + wallet.wallet.createdBy.lastNames }}</strong></p>
                    </div>
                    <div class="p-card-container wallet-section">
                        <p class="p-card-text">Arrendamientos activos: <strong>{{ wallet.amounts.leaseCount }}</strong></p>
                    </div>
                </div>
            </p-card>

            <p-card class="col-4 card-wallet">
                <div class="flex flex-column gap-3">
                    <div class="p-card-container wallet-section">
                        <p class="p-card-text">Valor cartera: <strong>{{ wallet.amounts.wallet | currency }}</strong></p>
                    </div>
                    <div class="p-card-container wallet-section">
                        <p class="p-card-text">Cartera sin accesorios: <strong>{{ wallet.amounts.walletWithoutAccessories | currency }}</strong></p>
                    </div>
                </div>
            </p-card>
        </div>

        <!-- Tabla -->
        <div class="row">
            <div class="col-12">
                <app-main-table 
                    [columns]="columns"
                    [pluralEntityName]="'créditos'"
                    [apiService]="apiWalletService"
                ></app-main-table>
            </div>
        </div>
    </ng-template>
</p-card>

<!-- 🦴 Skeleton para el título -->
<ng-template #skeletonTitle>
    <p-skeleton width="40%" height="24px"></p-skeleton>
</ng-template>
